/* unplugin-vue-components disabled */import script from "./app-banner.vue?vue&type=script&setup=true&lang=ts"
export * from "./app-banner.vue?vue&type=script&setup=true&lang=ts"

import "./app-banner.vue?vue&type=style&index=0&id=7177d50f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7177d50f"]])

export default __exports__